import { Card, Badge, Table, Typography } from "antd"
const { Title, Text } = Typography;

const Signal = () => {
  
  const signalMappingData = [
    {
      key: "1",
      signal: "AI Regulation Trend",
      signalType: "Regulatory Signal",
      action: "Compliance Automation",
      outcome: "$350K cost avoided",
      timeline: "21 days",
      confidence: "91%",
    },
    {
      key: "2",
      signal: "Supply Chain Disruption",
      signalType: "Risk Signal",
      action: "Vendor Diversification",
      outcome: "$240K loss prevented",
      timeline: "14 days",
      confidence: "88%",
    },
    {
      key: "3",
      signal: "Market Expansion Opportunity",
      signalType: "Growth Signal",
      action: "GTM Strategy Launch",
      outcome: "$180K revenue gain",
      timeline: "7 days",
      confidence: "94%",
    },
  ]

  const signalMappingColumns = [
    {
      title: "Signal",
      dataIndex: "signal",
      key: "signal",
      render: (text, record) => (
        <div>
          <Text strong>{text}</Text>
          <br />
          <Text type="secondary" style={{ fontSize: "12px" }}>
            {record.signalType}
          </Text>
        </div>
      ),
    },
    {
      title: "Action Taken",
      dataIndex: "action",
      key: "action",
    },
    {
      title: "Financial Outcome",
      dataIndex: "outcome",
      key: "outcome",
      render: (text) => <Text style={{ color: "#52c41a", fontWeight: "bold" }}>{text}</Text>,
    },
    {
      title: "Timeline",
      dataIndex: "timeline",
      key: "timeline",
    },
    {
      title: "Confidence",
      dataIndex: "confidence",
      key: "confidence",
      render: (text) => <Badge color="blue" text={text} />,
    },
  ]
  return (
    <Card style={{ marginBottom: "24px" }}>
          <Title level={4}>Signal-to-Financial Mapping Matrix</Title>
          <Text type="secondary">Links signals → actions taken → financial outcome</Text>

          <Table
            dataSource={signalMappingData}
            columns={signalMappingColumns}
            pagination={false}
            size="middle"
            style={{ marginTop: "16px" }}
          />
        </Card>
  )
}

export default Signal